// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-a8a5f06a","scoped":true,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/LiveRun/Race/RaceDetail.vue
// module id = 1284
// module chunks = 2